import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        appid: "",
        callback_url: "",
        params: []
      },
      imgList: [],
      rules: {
        appid: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        callback_url: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        params: [{
          required: true,
          message: "请添加参数",
          trigger: "blur"
        }],
        lable: [{
          required: true,
          message: "请输入键",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "请输入值",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var list, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getcommonData(['appListAllData']);

              case 2:
                _this.copyPrimitive();

                if (data) {
                  list = [];

                  for (key in data.params) {
                    list.push({
                      lable: key,
                      value: data.params[key]
                    });
                  }

                  _this.formData = _objectSpread(_objectSpread({}, data), {}, {
                    params: list
                  });
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.params.push({
        lable: "",
        value: ""
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.params.indexOf(item);

      if (index !== -1) {
        this.formData.params.splice(index, 1);
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, size, d, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 14;
                    break;
                  }

                  data = JSON.parse(JSON.stringify(_this2.formData));
                  size = new Set(data.params.map(function (i) {
                    return i.lable;
                  })).size;

                  if (!(data.params.length !== size)) {
                    _context2.next = 6;
                    break;
                  }

                  _this2.$message.error('参数键不能输入相同的值');

                  return _context2.abrupt("return");

                case 6:
                  d = {};
                  data.params.forEach(function (item, index) {
                    d[item.lable] = item.value;
                  });
                  data.params = JSON.stringify(d);

                  if (!_this2.formData.id) {
                    _context2.next = 12;
                    break;
                  }

                  _context2.next = 12;
                  return _this2.secondConfirmation();

                case 12:
                  reqFn = data.id ? 'appGatewaySdkConfigUpdate' : 'appGatewaySdkConfigAdd';

                  _this2.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};